import { ClickEvent, DataHeader, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutCommodity } from "./autogen/AutogenLayoutCommodity";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

const viewCommodityURL = "lme/dispatch/Commodity?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName:"commodity",
    screenName:"Commodity",
    navigateToUrl:viewCommodityURL
};

export class Commodity extends AutogenLayoutCommodity {
    override onLoad() {
        this.layoutTableComments.displayCopyOrderFields = false
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
        this.textboxHazmatNumber.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            if (event.hasSelection() === true) {
                this.activeRow.set("hazmat_proper_shipname", event.selection.get("hazmat_proper_shipname"));
                this.activeRow.set("hazmat_class_code", event.selection.get("hazmat_class_code"));
                this.activeRow.set("hazmat_packing_group", event.selection.get("hazmat_packing_group"));
                this.activeRow.set("hazmat_erg_number", event.selection.get("hazmat_erg_number"));
            }
        });
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    switchPoisonInhalationHazardOnChange(event: ClickEvent) {
        this.textboxZone.visible = this.textboxZone.required = this.activeRow.getBoolean("is_poison");
    }
}
